var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updating)?_c('div',{staticClass:"busy-indicator"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fa fa-spinner fa-spin fa-5x fa-fw overlay logo_icon"})])
}]

export { render, staticRenderFns }